<template>
    <v-row row justify-center>
        <v-dialog persistent transition="scale-transition" max-width="376" v-model="dialogModel">
            <v-card>
                <toolbar-page title="Session expired"></toolbar-page>

                <v-card-text class="pt-5">
                    Your session has expired. Typically this is caused by session timeout. Or perhaps you logged off in an another session?
                </v-card-text>

                <v-card-actions>
                    <v-btn color="primary" class="ml-2 mb-2" @click="sendToUrl('/')">Login</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>

    import ToolbarPage from "../UI/ToolbarPage";

    export default {

        components: {
            ToolbarPage
        },

        data: function () {
            return {
                dialogModel: true
            }
        },
    }
</script>

